import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../services/PostData';
import { GetData } from '../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import ManagePage from '../views/ManagePage';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../Loader';

const GLOBAL = require('../Globals');

class Homework extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			idd: '',
			hdesc: null,
			hdate: null,
			accyear: [],
			sec: [],
			secup: [],
			secupdata: '',
			isUnicode: 0,
			loading: false,
			acyear: '',
			cladata: [],
			classdata: '',
			_message: '',
			currentPage: 1,
			todosPerPage: 20,
			activePage: 1,
			//value : '',
			alertClass: '',
			//_redirect : false,
			posts: []
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.handleSMS = this.handleSMS.bind(this);
		//this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
	}


	onShowChange(e) {
		this.state.todosPerPage = e.target.value;


		this.getdata();

	}
	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		console.log(this.state);
	}

	onChkChange(e) {

		if (e.target.checked) {

			this.state.isUnicode = 1;
		}
		else {

			this.state.isUnicode = 0;
		}

	}

	onClick(e) {

		document.getElementById("hwform").reset();
	}

	handlePageChange(pageNumber) {

		this.setState({ activePage: pageNumber });
		this.state.currentPage = Number(pageNumber);
	}

	handleClick(dd) {

		this.state.id = dd;
		console.log('id' + this.state.id);

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('homework/removehomework', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Homework Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove Homework',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	handleSMS(dd) {

		this.state.id = dd;
		console.log('id' + this.state.id);

		if (window.confirm("Do you want to Send SMS?")) {
			$("#showLoader").show();
			this.setState({ loading: true });

			PostData('homework/sendhomework', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Homework Send Successfullly',
						alertClass: 'alert alert-success',
						loading: false
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Send Homework',
						alertClass: 'alert alert-danger',
						loading: false
					});
				}
			});
		}
	}

	/* set value to react select 
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}*/
	onBack() {

		this.setState({ idd: '' });

	}

	onUpdate(dt) {

		this.state.idd = dt;
		this.gethwdata();
		this.getsectionup();

	}

	gethwdata() {
		$("#showLoader").show();
		GetData('homework/gethomeworkbyid/' + this.state.idd).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					acyear: res[0]['acyear'],
					classdata: res[0]['class'],
					secupdata: res[0]['section'],
					hdesc: res[0]['content'],
					isUnicode: res[0]['isunicode'],
					hdate: res[0]['dateon']
				});
				if (this.state.isUnicode == 1) {

					$("#isUnicodeup").prop("checked", true);
				}
				if (this.state.isUnicode == 0) {
					$("#isUnicodeup").prop("checked", false);
				}
			}
		});
	}

	onupdateSubmit(e) {
		e.preventDefault();
		console.log(this.state);
		if (this.state.idd) {
			$("#showLoader").show();
			PostData('homework/updatehomework', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Homework Updated Successfully!..',
						alertClass: 'alert alert-success',
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Invalid Key',
						alertClass: 'alert alert-danger'
					});
					this.getdata();
				}
			});

		}

	}

	onSubmit(e) {
		e.preventDefault();

		if (this.state != '') {
			$("#showLoader").show();
			PostData('homework/savehomework', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Homework Added Successfully!..',
						alertClass: 'alert alert-success',
					});
					document.getElementById("hwform").reset();
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Already Added',
						alertClass: 'alert alert-danger'
					});
					document.getElementById("hwform").reset();
					this.getdata();
				}
			});

		}

	}

	componentWillMount() {

		this.getdata();
		this.getacyear();
		this.getclass();

	}

	/** get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				//this.getclass();
				this.getdata();
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					cladata: responseJson
				});
			}
		});
	}

	// Get Section By Class
	getsection() {
		var ac = $("#year").val();
		var fr = $("#clas").val()
		GetData('section/getsecbyclass/' + ac + '/' + fr).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sec: responseJson
				});
			}
		});
	}

	getsectionup() {

		GetData('homework/getsection/').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					secup: responseJson
				});
			}
		});
	}



	getdata() {
		this.setState({ loading: true });
		$("#showLoader").show();
		GetData('homework/gethomework').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson,
					loading: false
				});
				//$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}


	render() {

		this.state.user = sessionStorage.getItem('userData');
		this.state.user = JSON.parse(this.state.user);
		this.state.userId = this.state.user.userid;

		/*if(this.state._redirect){
			  
			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);
	
		}*/

		function getdateofdt(date) {

			var date1 = new Date(date);
			var year = date1.getFullYear();
			var month = (date1.getMonth() + 1);
			var day = date1.getDate()
			var strTime = day + '-' + month + '-' + year;
			return strTime;

		}

		var acyear = this.state.accyear;
		var classdata = this.state.cladata;
		var secupdata = this.state.secup;

		/** set showcount select box **/
		this.shows = [
			{ value: '10', name: '10' },
			{ value: '20', name: '20' },
			{ value: '50', name: '50' },
			{ value: '100', name: '100' }
		];

		$("#clas").change(function () {

			var ar = $("#year").val();
			var fr = $(this).val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL + 'section/getsecbyclass/' + ar + '/' + fr, function (o) {
				$("#showLoader").hide();
				$("#secs").html('');
				$('#secs')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Section- '));
				$.each(o, function (key, value) {
					$('#secs')
						.append($("<option></option>")
							.attr("value", value.section)
							.text(value.secs));

				});

			}, 'json');


		});

		$("#clasup").change(function () {

			var ar = $("#yearup").val();
			var fr = $(this).val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL + 'section/getsecbyclass/' + ar + '/' + fr, function (o) {
				$("#showLoader").hide();
				$("#secsup").html('');
				$('#secsup')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Section- '));
				$.each(o, function (key, value) {
					$('#secsup')
						.append($("<option></option>")
							.attr("value", value.section)
							.text(value.secs));

				});

			}, 'json');

		});

		$('#msgarea').keyup(function () {

			var chars = this.value.length;
			if ($("#isUnicode").prop("checked")) {
				var messages1 = Math.ceil(chars / 70),
					remaining1 = messages1 * 70 - (chars % (messages1 * 70) || messages1 * 70);
			}
			else {
				var messages1 = Math.ceil(chars / 160),
					remaining1 = messages1 * 160 - (chars % (messages1 * 160) || messages1 * 160);
			}

			$("#remaining1").text(remaining1 + ' characters remaining ');
			$("#messages1").text(messages1 + ' message(s)')

		});

		if (this.state.idd != '') {

			$("#edithw").show();
			$("#addhw").hide();
		}
		else {

			$("#edithw").hide();
			$("#addhw").show();
		}

		// Logic for displaying current todos
		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.posts.slice(indexOfFirstTodo, indexOfLastTodo);

		const renderTodos = currentTodos.map((item, i) => {

			return <tr key={item}>
				<td width="20">{i + 1}</td>
				<td width="60">{item.classname} - {item.sec}</td>
				<td width="60">{getdateofdt(item.dateon)}</td>
				<td width="120">{item.content}</td>
				<td width="40">{item.isdelivered === '1' ? 'Delivered' : 'New'}</td>
				<td width="70">
					<button name="edithw" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
					&nbsp;
									<button name="sendhw" className="btn btn-primary btn-sm" disabled={item.isdelivered === '1' ? true : false} onClick={() => this.handleSMS(item.id)} ><i className="fa fa-envelope"></i></button>
					&nbsp;
									<button name="removeann" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
				</td>
			</tr>;

		});

		return (
			<div>
				<ManagePage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="5" id="addhw">
							<Card>
								<form action="" method="post" role="form" id="hwform" encType="multipart/form-data" onSubmit={this.onSubmit} >
									<CardHeader>
										<strong>Add Homework</strong>

									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Academic Year<span className="text-danger">*</span></Label>
													<select name="acyear" className="form-control" onChange={this.onChange} required id="year">
														<option value="">Select Academic Year</option>
														{
															acyear.map(function (item) {
																return <option value={item.id}>{item.value}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Class<span className="text-danger">*</span></Label>
													<select name="classdata" className="form-control" onChange={this.onChange} required id="clas">
														<option value="">Select Class</option>
														{
															classdata.map(function (item) {
																return <option value={item.id}>{item.class}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Section<span className="text-danger">*</span></Label>
													<select name="section" onChange={this.onChange} className="form-control" id="secs">

													</select>
												</FormGroup>
											</Col>

											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Home Work <span className="text-danger">*</span></Label>
													<Input type="textarea" name="hdesc" id="msgarea" rows="5" required onChange={this.onChange} />
													<span id="remaining1">160 characters remaining </span>
													<span id="messages1">1 message(s)</span>
												</FormGroup>
												<FormGroup check inline>
													<Label className="form-check-label" check htmlFor="inline-checkbox1" >Unicode Message</Label>&nbsp;&nbsp;&nbsp;
									<Input className="form-check-input" onChange={this.onChange} type="checkbox" id="isUnicode" name="isUnicode" value="1" />
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Date<span className="text-danger">*</span></Label>
													<Input type="date" name="hdate" required onChange={this.onChange} />
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
										<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
									</CardFooter>
								</form>
							</Card>
						</Col>
						<Col md="5" id="edithw">
							<Card>
								<form action="" method="post" role="form" id="hwform" encType="multipart/form-data" onSubmit={this.onupdateSubmit} >
									<CardHeader>
										<strong>Update Homework</strong>
										<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add</Button>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Academic Year<span className="text-danger">*</span></Label>
													<select name="acyear" className="form-control" onChange={this.onChange} value={this.state.acyear} required id="yearup">
														<option value="">Select Academic Year</option>
														{
															acyear.map(function (item) {
																return <option value={item.id}>{item.value}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Class<span className="text-danger">*</span></Label>
													<select name="classdata" className="form-control" onChange={this.onChange} value={this.state.classdata} required id="clasup">
														<option value="">Select Class</option>
														{
															classdata.map(function (item) {
																return <option value={item.id}>{item.class}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Section<span className="text-danger">*</span></Label>
													<select name="secupdata" onChange={this.onChange} value={this.state.secupdata} className="form-control" id="secsup">
														<option value="">Select Section</option>
														{
															secupdata.map(function (item) {
																return <option value={item.id}>{item.section}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>

											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Home Work<span className="text-danger">*</span></Label>
													<Input type="textarea" name="hdesc" id="msgarea" rows="5" required onChange={this.onChange} value={this.state.hdesc} />
													<span id="remaining1">160 characters remaining </span>
													<span id="messages1">1 message(s)</span>
												</FormGroup>
												<FormGroup check inline>
													<Label className="form-check-label" check htmlFor="inline-checkbox1" >Unicode Message</Label>&nbsp;&nbsp;&nbsp;
									<Input className="form-check-input" onChange={this.onChkChange} type="checkbox" id="isUnicodeup" name="isUnicode" />
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Date<span className="text-danger">*</span></Label>
													<Input type="date" name="hdate" required onChange={this.onChange} value={this.state.hdate} />
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
									</CardFooter>
								</form>
							</Card>
						</Col>
						<Col md="7">
							<Card>
								<CardHeader>
									<strong>Homeworks</strong>

								</CardHeader>
								<CardBody>

									<Col md="12">
										<Table responsive bordered>
											<thead>
												<tr>
													<th width="20">S.No</th>
													<th width="60">Class</th>
													<th width="60">Date</th>
													<th width="120">Content</th>
													<th width="40">Status</th>
													<th width="70">Manage</th>
												</tr>
											</thead>
											<tbody>
												{this.state.loading ? <tr><td colSpan="6"><center>{'No Data Found'}</center></td></tr> : renderTodos}
											</tbody>
										</Table>
									</Col>
									<Col md="4">
										<Pagination
											activePage={this.state.activePage}
											itemsCountPerPage={this.state.todosPerPage}
											pageRangeDisplayed={3}
											totalItemsCount={this.state.posts.length}
											onChange={this.handlePageChange}
										/>
									</Col>
									<Col md="2">
										<select name="show" onChange={this.onShowChange} id="show" >
											{this.shows.map((e, key) => {
												return <option key={key} value={e.value}>{e.name}</option>;
											})}
										</select>&nbsp;
								   entries
					  </Col>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default Homework;


// WEBPACK FOOTER //
// ./src/homework/homework.js